import React, { Component } from 'react'

import PropTypes from 'prop-types'

import { HelperCopy } from '../../text'
import { ERROR_MESSAGE } from '../constants'
import { ErrorMessageText } from '../ImageJuxtFrame/style'

import {
  RightErrorMessageContainer,
  RightErrorMessageTextContainer,
  RightImage,
  RightImageContainer,
} from './style'

const ACCESSIBILITY_LABEL = 'Image juxtaposition right image container'

class ImageJuxtRightImageComponent extends Component {
  getRenderProps = () => {
    const {
      alt: accessibilityLabel,
      errorMessageTextWidth,
      errorMessageWidth,
      onError,
      showError,
      source,
    } = this.props
    const imageContainerProps = {
      accessibilityLabel: ACCESSIBILITY_LABEL,
    }
    const imageProps = {
      accessibilityLabel,
      onError,
      showError,
      source,
    }
    const errorMessageContainerProps = {
      width: errorMessageWidth,
    }
    const errorMessageTextContainerProps = {
      width: errorMessageTextWidth,
    }

    return {
      errorMessageContainerProps,
      errorMessageTextContainerProps,
      imageContainerProps,
      imageProps,
      showError,
    }
  }

  getComponent = () => {
    const {
      imageProps,
      errorMessageContainerProps,
      errorMessageTextContainerProps,
      showError,
    } = this.getRenderProps()
    const rightImageComponent = showError ? (
      <RightErrorMessageContainer {...errorMessageContainerProps}>
        <RightErrorMessageTextContainer {...errorMessageTextContainerProps}>
          <ErrorMessageText>
            <HelperCopy>{ERROR_MESSAGE}</HelperCopy>
          </ErrorMessageText>
        </RightErrorMessageTextContainer>
      </RightErrorMessageContainer>
    ) : (
      <RightImage {...imageProps} />
    )

    return rightImageComponent
  }

  render = () => {
    const { imageContainerProps } = this.getRenderProps()
    const rightImageComponent = this.getComponent()

    return (
      <RightImageContainer {...imageContainerProps}>
        {rightImageComponent}
      </RightImageContainer>
    )
  }
}

ImageJuxtRightImageComponent.propTypes = {
  alt: PropTypes.string,
  errorMessageTextWidth: PropTypes.number,
  errorMessageWidth: PropTypes.number,
  onError: PropTypes.func,
  showError: PropTypes.bool,
  source: PropTypes.string,
}

ImageJuxtRightImageComponent.defaultProps = {
  alt: "' '",
  errorMessageTextWidth: 0,
  errorMessageWidth: 0,
  onError() {},
}

export default ImageJuxtRightImageComponent
